import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './btpg-footer.component.html';
var BtpgFooterComponent = (function () {
    function BtpgFooterComponent() {
    }
    BtpgFooterComponent.$inject = [];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BtpgFooterComponent.prototype, "text", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BtpgFooterComponent.prototype, "videoBtnText", void 0);
    BtpgFooterComponent = __decorate([
        Component({
            selector: 'btpgFooter',
            template: template,
        })
    ], BtpgFooterComponent);
    return BtpgFooterComponent;
}());
export { BtpgFooterComponent };
